import { useState, useEffect } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { gettravelHotel } from "../../store/slices/travelhotel";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function RoomType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { travelHotelList = [] } = useSelector((state) => state.travelHotel);

  const [currentPage, setCurrentPage] = useState(1);
  const pageLimit = 20;

  const fetchHotels = async () => {
    try {
      await dispatch(gettravelHotel()).unwrap();
    } catch (error) {
      toast.error("Failed to fetch hotels");
    }
  };

  useEffect(() => {
    fetchHotels();
  }, []);

  const hotelList = Array.isArray(travelHotelList) ? travelHotelList : [];

  const totalPages = Math.ceil(hotelList.length / pageLimit);
  const startIndex = (currentPage - 1) * pageLimit;
  const currentHotels = hotelList.slice(startIndex, startIndex + pageLimit);

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">|</span>
          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/roomtype")}
          >
            Room Type
          </span>
        </div>
      </div>

      <Container fluid>
        <div className="roomtype-grid">
          {currentHotels.length === 0 && (
            <div className="text-center py-5 text-muted">No Hotels Found</div>
          )}

          <div className="row g-4">
            {currentHotels.map((item, index) => (
              <div className="col-lg-3 col-md-4 col-sm-6" key={item._id}>
                <Card className="hotel-select-card h-100">
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div>
                      <div className="hotel-icon-img">
                        <img src={item.image} alt={item.name} />
                      </div>

                      <h6 className="fw-semibold mt-3 mb-1 text-truncate">
                        {item.name}
                      </h6>

                      <p className="text-muted small mb-3">
                        Select hotel to manage room types
                      </p>
                    </div>

                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="w-100"
                      onClick={() => navigate(`/admin/hotel-rooms/${item._id}`)}
                    >
                      View Rooms →
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                size="sm"
                variant="light"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </Button>

              {[...Array(totalPages)].map((_, i) => (
                <Button
                  key={i}
                  size="sm"
                  variant={currentPage === i + 1 ? "primary" : "light"}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Button>
              ))}

              <Button
                size="sm"
                variant="light"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </Button>
            </div>
          )}
        </div>
      </Container>
    </>
  );
}
